export default function About() {
  return (
    <section id="about" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Visual Area */}
          <div className="relative animate-slide-in-left">
            <div className="rounded-[48px] overflow-hidden shadow-2xl relative">
              <img
                src="https://public.readdy.ai/ai/img_res/facf57374500406d27fe5d23eda9de26.jpg"
                alt="Happy pets with caretakers"
                className="w-full h-auto object-cover object-top"
              />

              {/* Badge overlay */}
              <div className="absolute top-8 right-8 bg-[#FF9B9B] text-white px-6 py-3 rounded-full shadow-lg transform rotate-[-5deg] animate-float">
                <p className="font-bold text-lg whitespace-nowrap">10+ Years Experience</p>
              </div>
            </div>

            {/* Floating decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 flex items-center justify-center bg-[#FFE5EC] rounded-full shadow-lg animate-pulse">
              <i className="ri-heart-fill text-[#FF9B9B] text-3xl"></i>
            </div>
            <div className="absolute -top-6 -right-6 w-20 h-20 flex items-center justify-center bg-[#E6E0F5] rounded-full shadow-lg animate-bounce">
              <i className="ri-star-fill text-[#8B7BA8] text-2xl"></i>
            </div>
          </div>

          {/* Right Content Area */}
          <div className="space-y-6 lg:pl-12 animate-slide-in-right">
            <div className="inline-flex items-center gap-2 bg-[#5B4570] px-4 py-2 rounded-full">
              <i className="ri-sparkle-fill text-white"></i>
              <span className="text-sm font-medium text-white">About Our Mission</span>
            </div>

            <h2 className="text-5xl lg:text-6xl font-bold text-[#4A3B5C] leading-tight font-heading">
              Creating Joyful
              <br />
              Moments Together
            </h2>

            <div className="space-y-6">
              <p className="text-lg text-[#8B7BA8] leading-relaxed">
                At PawCare, we believe every pet deserves exceptional care and unconditional love. Our team of dedicated professionals combines years of experience with genuine passion for animal welfare, creating a nurturing environment where your furry friends can thrive.
              </p>

              <p className="text-lg text-[#8B7BA8] leading-relaxed">
                From routine check-ups to specialized treatments, grooming to boarding, we offer comprehensive services tailored to meet your pet's unique needs. Your pet's happiness is our greatest reward.
              </p>
            </div>

            <button className="bg-[#5B4570] text-white px-12 py-5 rounded-[30px] hover:bg-[#FF9B9B] hover:text-white transition-all duration-300 font-medium text-lg flex items-center gap-3 shadow-md hover:shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer mt-8">
              Discover Our Story
              <i className="ri-arrow-right-up-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
